/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import { Flex, Icon, View } from "@aws-amplify/ui-react";
export default function EmailIcon(props) {
  const { overrides, ...rest } = props;
  return (
    <Flex
      gap="10px"
      direction="row"
      alignItems="flex-start"
      position="relative"
      padding="0px 0px 0px 0px"
      {...getOverrideProps(overrides, "EmailIcon")}
      {...rest}
    >
      <View
        width="96px"
        height="96px"
        shrink="0"
        overflow="hidden"
        position="relative"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "Ic\u00F4ns_app_Mail 1")}
      >
        <Icon
          width="46.642578125px"
          height="24.3956298828125px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 46.642578125,
            height: 24.3956298828125,
          }}
          paths={[
            {
              d: "M5.625 7.73438C5.62451 7.21132 5.72711 6.69329 5.92693 6.20991C6.12676 5.72652 6.41989 5.28726 6.78957 4.91722C7.15926 4.54719 7.59824 4.25365 8.08144 4.05337C8.56464 3.85309 9.08257 3.75 9.60563 3.75L46.6425 3.75C46.5841 2.73653 46.1406 1.7837 45.4027 1.08656C44.6648 0.389425 43.6883 0.000713274 42.6731 4.42052e-07L3.98063 4.42052e-07C3.45781 -0.000245993 2.94008 0.102547 2.45702 0.302505C1.97395 0.502463 1.53503 0.795665 1.16535 1.16535C0.795665 1.53503 0.502466 1.97395 0.302508 2.45702C0.10255 2.94008 -0.000245993 3.45781 4.42039e-07 3.98062L4.42039e-07 24.3956L5.625 24.3956L5.625 7.73438Z",
              fill: "rgba(255,106,20,0.25)",
              fillRule: "nonzero",
            },
          ]}
          position="absolute"
          top="28.13%"
          bottom="46.46%"
          left="25.71%"
          right="25.71%"
          {...getOverrideProps(overrides, "Vector34691301")}
        ></Icon>
        <Icon
          width="71.25px"
          height="39.7425537109375px"
          viewBox={{ minX: 0, minY: 0, width: 71.25, height: 39.7425537109375 }}
          paths={[
            {
              d: "M10.5956 34.1194C9.94272 34.1194 9.2962 33.9907 8.69302 33.7408C8.08983 33.4909 7.54179 33.1246 7.0802 32.6628C6.61861 32.2011 6.25252 31.6529 6.00283 31.0496C5.75314 30.4463 5.62475 29.7998 5.625 29.1469L5.625 3.41437L0.091876 0L0 0L0 34.7719C2.66454e-15 36.0902 0.52369 37.3545 1.45586 38.2866C2.38804 39.2188 3.65233 39.7425 4.97063 39.7425L66.2831 39.7425C67.6008 39.7415 68.8641 39.2174 69.7955 38.2853C70.7268 37.3532 71.25 36.0895 71.25 34.7719L71.25 34.1175L10.5956 34.1194Z",
              fill: "rgba(255,106,20,0.25)",
              fillRule: "nonzero",
            },
          ]}
          position="absolute"
          top="44.44%"
          bottom="14.16%"
          left="12.94%"
          right="12.84%"
          {...getOverrideProps(overrides, "Vector34691302")}
        ></Icon>
        <Icon
          width="75.0078125px"
          height="72.427734375px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 75.0078125,
            height: 72.427734375,
          }}
          paths={[
            {
              d: "M74.985 30.6638L74.985 30.6057C74.9738 30.5326 74.9587 30.4613 74.94 30.3882C74.94 30.3788 74.94 30.3676 74.94 30.3563C74.9212 30.2944 74.9006 30.2344 74.8763 30.1688L74.8538 30.1163C74.8275 30.0582 74.7994 30.0001 74.7675 29.9438C74.7675 29.9438 74.7581 29.9269 74.7525 29.9176C74.7136 29.8523 74.6704 29.7896 74.6231 29.7301C74.6173 29.7211 74.6104 29.7129 74.6025 29.7057C74.563 29.6556 74.5204 29.608 74.475 29.5632C74.46 29.5463 74.445 29.5332 74.43 29.5182C74.415 29.5032 74.3438 29.4413 74.2988 29.4057L74.2537 29.3682C74.2537 29.3682 74.2031 29.3682 74.1975 29.3551L62.625 21.0732L62.625 19.1982C62.6324 18.4396 62.4903 17.6871 62.2068 16.9834C61.9233 16.2798 61.504 15.6389 60.9727 15.0974C60.4415 14.5559 59.8088 14.1244 59.1107 13.8275C58.4126 13.5305 57.6629 13.374 56.9044 13.3669L55.0987 13.3669L38.6606 0.39944C38.3257 0.136832 37.9113 -0.00400246 37.4857 8.65954e-05C37.0601 0.00417565 36.6486 0.152946 36.3187 0.42194L20.37 13.3688L18.1538 13.3688C17.3946 13.3683 16.6428 13.5175 15.9413 13.8079C15.2398 14.0982 14.6025 14.524 14.0658 15.0609C13.5291 15.5978 13.1035 16.2353 12.8133 16.9368C12.5232 17.6384 12.3743 18.3903 12.375 19.1494L12.375 19.6594L0.705 29.4432L0.68625 29.4432C0.474817 29.6183 0.303947 29.8373 0.185459 30.0849C0.066971 30.3326 0.00369274 30.603 2.60212e-07 30.8776L2.60212e-07 65.6494C-0.00048065 67.3923 0.665651 69.0694 1.86188 70.3369C1.9335 70.4129 2.01266 70.4814 2.09813 70.5413C3.37551 71.7641 5.07925 72.4407 6.8475 72.4276L68.16 72.4276C69.053 72.4345 69.9385 72.2653 70.7661 71.9297C71.5936 71.5942 72.3469 71.0988 72.9829 70.4719C73.6188 69.845 74.125 69.0989 74.4724 68.2762C74.8198 67.4536 75.0016 66.5705 75.0075 65.6776L75.0075 30.8776C75.0075 30.8663 75.0075 30.8551 75.0075 30.8438C75 30.7838 75 30.7238 74.985 30.6638ZM3.75 65.6494L3.75 34.1813L12.375 39.4557L12.375 39.6151L12.5438 39.6151L27.5437 48.8644L3.84375 66.3994C3.78287 66.154 3.75139 65.9023 3.75 65.6494L3.75 65.6494ZM30.9788 50.9457L33.9075 52.7701C34.9848 53.442 36.2285 53.7993 37.4981 53.8016C38.7678 53.8039 40.0128 53.4512 41.0925 52.7832L43.965 50.9832L67.965 68.6757L6.96375 68.6757L30.9788 50.9457ZM47.4075 48.9094L62.5181 39.6132L62.625 39.6132L62.625 39.4932L71.25 34.2319L71.25 65.6494C71.2488 65.916 71.2135 66.1812 71.145 66.4388L47.4075 48.9094ZM69.6675 30.7557L62.625 35.0869L62.625 25.6932L69.6675 30.7557ZM37.5169 4.28069L49.0406 13.3651L26.3213 13.3651L37.5169 4.28069ZM18.1538 17.1151L56.8462 17.1151C57.1118 17.1141 57.375 17.1654 57.6208 17.2662C57.8665 17.367 58.0899 17.5152 58.2784 17.7024C58.4668 17.8896 58.6164 18.1121 58.7188 18.3572C58.8212 18.6023 58.8743 18.8651 58.875 19.1307L58.875 37.3988L39.0881 49.6013C38.611 49.9023 38.0585 50.062 37.4944 50.062C36.9303 50.062 36.3777 49.9023 35.9006 49.6013L16.125 37.3632L16.125 19.1963C16.1094 18.66 16.3074 18.1394 16.6755 17.7491C17.0437 17.3588 17.5518 17.1307 18.0881 17.1151L18.1538 17.1151ZM12.375 35.0494L5.18062 30.6094L12.375 24.5532L12.375 35.0494Z",
              fill: "rgba(51,63,72,1)",
              fillRule: "nonzero",
            },
          ]}
          position="absolute"
          top="12.28%"
          bottom="12.28%"
          left="10.94%"
          right="10.93%"
          {...getOverrideProps(overrides, "Vector34691303")}
        ></Icon>
        <Icon
          width="24.75px"
          height="3.75px"
          viewBox={{ minX: 0, minY: 0, width: 24.75, height: 3.75 }}
          paths={[
            {
              d: "M22.875 0L1.875 0C0.839466 0 0 0.839466 0 1.875C0 2.91053 0.839466 3.75 1.875 3.75L22.875 3.75C23.9105 3.75 24.75 2.91053 24.75 1.875C24.75 0.839466 23.9105 0 22.875 0Z",
              fill: "rgba(255,106,20,1)",
              fillRule: "nonzero",
            },
          ]}
          position="absolute"
          top="38.83%"
          bottom="57.26%"
          left="37.11%"
          right="37.11%"
          {...getOverrideProps(overrides, "Vector34691304")}
        ></Icon>
        <Icon
          width="24.75px"
          height="3.75px"
          viewBox={{ minX: 0, minY: 0, width: 24.75, height: 3.75 }}
          paths={[
            {
              d: "M22.875 0L1.875 0C0.839466 0 0 0.839466 0 1.875C0 2.91053 0.839466 3.75 1.875 3.75L22.875 3.75C23.9105 3.75 24.75 2.91053 24.75 1.875C24.75 0.839466 23.9105 0 22.875 0Z",
              fill: "rgba(255,106,20,1)",
              fillRule: "nonzero",
            },
          ]}
          position="absolute"
          top="47.62%"
          bottom="48.47%"
          left="37.11%"
          right="37.11%"
          {...getOverrideProps(overrides, "Vector34691305")}
        ></Icon>
      </View>
    </Flex>
  );
}
